import apiSportEvents from '@/api/sports-events'

const state = {
  data: [],
  isLoading: false,
  error: null
}

export const mutationTypes = {
  getSportEventsListStart: '[sport events list] Get sport events start',
  getSportEventsListSuccess: '[sport events list] Get sport events success',
  getSportEventsListFailure: '[sport events list] Get sport events failure'
}

export const actionTypes = {
  getSportEventsList: '[sport events list] Get sport events'
}

const mutations = {
  [mutationTypes.getSportEventsListStart](state) {
    state.isLoading = true
    state.error = null
    state.data = []
  },

  [mutationTypes.getSportEventsListSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getSportEventsListFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  }
}

const actions = {
  [actionTypes.getSportEventsList](context, params) {
    context.commit(mutationTypes.getSportEventsListStart)
    return new Promise(resolve => {
      apiSportEvents
        .getSportEventsList(params)
        .then(response => {
          context.commit(mutationTypes.getSportEventsListSuccess, response.data)
          resolve(response.data)
        })
        .catch(error => {
          context.commit(mutationTypes.getSportEventsListFailure, error)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
